import React,{ useState, useEffect } from "react";
import { 
    Button,
    Form,
    Input
} from 'antd';
import axios from 'axios'; 
import ReactMarkdown from 'react-markdown';

function Chatbot() {
    const [ responseMessages, setResponseMessages ] = useState( [] );
    const [ prompLoading, setPromptLoading ] = useState( false );
    const [ imgLoading, setImgLoading ] = useState( false );
    const [ chatHistory, setChatHistory ] = useState( [] );
    const [ chatIndex, setChatIndex ] = useState( 0 );
    const [ promptValue, setPromptValue ] = useState( '' );
    const [ imgUrl, setImgUrl ] = useState( '' );
    const siteDomain = headerVars.siteDomain;
    const [form] = Form.useForm();

    const handleupdatePrompt = ( e ) => {
        setPromptValue( e.target.value );
    }

    const handleFetchGPTResponse = () => {
        let form_data = new FormData;
        form_data.append('action', 'startca_handle_get_openai_response');
        form_data.append('prompt_value', promptValue);
        let requestUrl = {ajax_url : siteDomain+"/wp-admin/admin-ajax.php"};

        console.log( '::', chatHistory.length );
        setPromptLoading( true );
        setChatHistory( chatHistory => ( [ ...chatHistory, <div id={ `prompt${chatIndex}` } style={{ fontWeight:'700', marginBottom:'2.5rem' }} >Prompt: {promptValue}</div> ] ) );
        setChatIndex( ( chatIndex ) => chatIndex + 1 );

        axios
        .post(requestUrl.ajax_url, form_data)
        .then(function( response ){
            let res = response.data;

            document.getElementById(`prompt${chatIndex}`).scrollIntoView();

            setChatHistory( chatHistory => ( [ ...chatHistory, <div style={{ fontWeight:'500', marginBottom:' 2rem' }} ><span style={{ fontWeight:'700' }}>Future overlord: </span><ReactMarkdown children={ res.choices[0].message.content } /></div> ] ) );

            //const lines = res.toString().split('\n').filter(line => line.trim() !== '');

            /*for (const line of lines) {
                const message = line.replace(/^data: /, '');

                if (message === '[DONE]') {
                    return; // Stream finished
                }
                try {
                    const parsed = JSON.parse(message);
                    console.log( 'parsed: ', parsed );
                    
                    setTimeout(() => { setResponseMessages( responseMessages => ( [ ...responseMessages, parsed.choices[0].delta.content ]) ); },100);
                } catch(error) {
                    console.error('Could not JSON parse stream message', message, error);
                }
            }*/
        }, [ chatHistory ])
        .catch(function (error) {
            console.log(error);
        })
        .finally(function () { 
            // always executed 
            setPromptLoading( false );
        });
    }

    const handleGenerateImage = () => {
        let form_data = new FormData;
        form_data.append('action', 'startca_handle_generate_image_from_prompt');
        form_data.append('prompt_value', promptValue);
        let requestUrl = {ajax_url : siteDomain+"/wp-admin/admin-ajax.php"};
        setImgLoading( true );

        axios
        .post(requestUrl.ajax_url, form_data)
        .then(function( response ){
            let res = response.data;
            console.log("res:: ", res);
            let imgUrl = res.data[0].url;
            setImgUrl( imgUrl );
        }, [])
        .catch(function (error) {
            console.log(error);
        })
        .finally(function () { 
            // always executed 
            setImgLoading( false ); 
        });
    }

    return (
        <div className="react-openai-ui-container">
            <Form
                layout={'horizontal'}
                form={form}
                style={{ margin: "5rem 0 2rem 0", display:"flex" }}
                >
                <Form.Item style={{ marginRight:"0.5rem", width:"50%" }} label="Prompt:">
                    <Input onChange={ handleupdatePrompt } placeholder="How can I help you?" />
                </Form.Item>
                <Form.Item>
                    <Button 
                        loading={ prompLoading } 
                        onClick={ handleFetchGPTResponse } 
                        type="primary">
                            Submit
                    </Button>
                    
                </Form.Item>
                <Form.Item style={{ marginLeft:"0.5rem", width:"50%" }} >
                    <Button 
                        loading={ imgLoading } 
                        onClick={ handleGenerateImage } 
                        type="default">
                            Generate image
                    </Button>
                </Form.Item>
            </Form>
            <div className="response-messages-container" style={{  }} >
                { chatHistory }
            </div>
            <div className="generated-image-container" style={{  }} >
                <img src={ imgUrl } />
            </div>
        </div>
    )
}

export default Chatbot